import {Component, inject, LOCALE_ID, OnInit} from '@angular/core';
import {NavigationEnd, Router,RouterOutlet} from '@angular/router';
import {EnvironmentComponent} from './components/environment/environment.component';
import {ToastMessage} from './models/toastMessage';
import {MessageService} from 'primeng/api';
import {ToastService} from './services/toast.service';
import {ToastModule} from 'primeng/toast';
import {User} from "./models/User/User";
import {AuthService} from "./services/auth.service";
import {ToastComponent} from "./components/toast/toast.component";
import {AddToCartComponent} from "./components/popups/add-to-cart/add-to-cart.component";
import {CartService} from "./services/cart.service";
import {ProductCart} from "./models/Cart/ProductCart";
import {WishlistService} from "./services/Wishlists/wishlist.service";
import {AddToWishlistComponent} from "./components/popups/add-to-wishlist/add-to-wishlist.component";
import {CurrencyService} from "./services/currency.service";
import {AsyncPipe, NgIf} from "@angular/common";
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { Title } from '@angular/platform-browser';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    EnvironmentComponent,
    ToastComponent,
    AddToCartComponent,
    AddToWishlistComponent,
    AsyncPipe,
    NgIf,
    GoogleTagManagerModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
    ToastModule,
    MessageService,
    {provide: LOCALE_ID, useValue: 'fr_FR'}
  ]
})
export class AppComponent implements OnInit {
  private titleService = inject(Title);
  private toastMessage: ToastMessage | null = null;
  userInfo: User | null = null;


  constructor(
    private messageService: MessageService,
    private errorService: ToastService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected wishlistService: WishlistService,
    private currencyService: CurrencyService,
    private gaService: GoogleAnalyticsService,
    private router : Router
    
  ) {
  }


  async ngOnInit() {
    if (location.protocol === 'http:') {
      window.location.href = location.href.replace('http:', 'https:');
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log(this.userInfo);
        const currentRoute = this.router.routerState.snapshot.root.firstChild;
        const pageTitle = currentRoute?.data['title'] || 'CVBG';
        this.titleService.setTitle(pageTitle);
        setTimeout(() => {
          this.gaService.sendPageView(event.urlAfterRedirects);
        }, 500);
      }
    });

    await this.currencyService.getCoursDevises();
    // this.authService.userAuthObservable$.subscribe( u => this.userInfo = u);

    
    const primeursCartSession = localStorage.getItem('primeursCartSession');
    if (primeursCartSession) {
      this.cartService.primeurCart.set(JSON.parse(primeursCartSession) as ProductCart[]);
    }

    const memCartSession = localStorage.getItem('memCartSession');
    if (memCartSession) {
      this.cartService.memCart.set(JSON.parse(memCartSession) as ProductCart[]);
    }

    const tarifCartSession = localStorage.getItem('tarifCartSession');
    if (tarifCartSession) {
      this.cartService.tarifCart.set(JSON.parse(tarifCartSession) as ProductCart[]);
    }

    this.errorService.getErrorMessageObservable().subscribe(message => {
      if (message !== this.toastMessage && message !== null) {
        this.toastMessage = message;
        this.messageService.add({
          severity: this.toastMessage.severite,
          summary: this.toastMessage.details,
          detail: this.toastMessage.message!,
          key: 'br'
        });
      }
    });
  }
}
